import utils from '@/assets/libs/utils'

export default {
  formatDate: (date = new Date(), format) => {
    return utils.formatDate(date, format).dateString
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js